module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjMzMjcgMi41NDY5OUwxNy40NTI3IDAuNjY2OTkyTDkuOTk5MzUgOC4xMjAzM0wyLjU0NjAyIDAuNjY2OTkyTDAuNjY2MDE2IDIuNTQ2OTlMOC4xMTkzNSAxMC4wMDAzTDAuNjY2MDE2IDE3LjQ1MzdMMi41NDYwMiAxOS4zMzM3TDkuOTk5MzUgMTEuODgwM0wxNy40NTI3IDE5LjMzMzdMMTkuMzMyNyAxNy40NTM3TDExLjg3OTMgMTAuMDAwM0wxOS4zMzI3IDIuNTQ2OTlaIiBmaWxsPSIjNjY2NTYzIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/reject_2.svg
// module id = nuCE
// module chunks = 1